import { createFileRoute } from "@tanstack/react-router";
import { SecurityAlertScreen } from "@modules/account-settings/views";

interface SecurityAlertSearch {
  /** The one-time token of the emailed link. Absent renders the "no usable link" state. */
  token?: string;
}

/**
 * `/account-security-alert`: the landing path of the « Votre mot de passe a été modifié » email's
 * button « Ce n'était pas moi ». The backend builds the link as
 * `{IDENTITY_PUBLIC_BASE_URL}/account-security-alert?token=...`, so this route has to match it.
 *
 * PUBLIC, deliberately: no `beforeLoad` guard. The person may have no session at all.
 */
export const Route = createFileRoute("/account-security-alert")({
  validateSearch: (search: Record<string, unknown>): SecurityAlertSearch => ({
    token: typeof search.token === "string" ? search.token : undefined,
  }),
  component: SecurityAlertRoute,
});

function SecurityAlertRoute() {
  const { token } = Route.useSearch();
  return <SecurityAlertScreen tokenFromUrl={token} />;
}
